import { barcodeLabelTemplateSchema } from "@redotech/redo-model/inventory/barcode-label-builder/barcode-label-definition";
import * as z from "zod";

export const createBarcodeLabelTemplate = {
  name: "createBarcodeLabelTemplate" as const,
  input: z.object({ name: z.string().min(1) }),
  output: z.object({ template: barcodeLabelTemplateSchema }),
};
